'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.LogProvider = undefined;

var _bluebird = require('bluebird');

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = require('events');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LogProvider = exports.LogProvider = function (_EventEmitter) {
	_inherits(LogProvider, _EventEmitter);

	function LogProvider() {
		var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;

		_classCallCheck(this, LogProvider);

		var _this = _possibleConstructorReturn(this, (LogProvider.__proto__ || Object.getPrototypeOf(LogProvider)).call(this));

		_this.cachedSettings = null;
		_this.fromFile = false;
		_this.cachedEntries = [];
		_this.hasMore = true;
		_this.poll = false;
		_this.pollActive = false;

		_this.baseLimit = limit;
		_this.loading = false;
		_this.limit = limit;
		_this.searchQuery = '';
		return _this;
	}

	_createClass(LogProvider, [{
		key: 'reset',
		value: function reset() {
			this.hasMore = true;
			this.limit = this.baseLimit;
			this.cachedEntries = [];
			this.loading = false;
		}
	}, {
		key: 'load',
		value: function () {
			var _ref = (0, _bluebird.coroutine)(regeneratorRuntime.mark(function _callee() {
				var newData;
				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								this.loading = true;

								if (!(this.cachedEntries.length >= this.limit || this.fromFile || !this.hasMore)) {
									_context.next = 3;
									break;
								}

								return _context.abrupt('return');

							case 3:
								_context.next = 5;
								return this.loadEntries(this.cachedEntries.length, this.limit - this.cachedEntries.length);

							case 5:
								newData = _context.sent;

								if (newData.data.length === 0) {
									this.hasMore = false;
								}
								this.cachedEntries = this.cachedEntries.concat(newData.data);
								this.loading = false;
								this.emit('entries', this.cachedEntries);

							case 10:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, this);
			}));

			function load() {
				return _ref.apply(this, arguments);
			}

			return load;
		}()
	}, {
		key: 'loadEntries',
		value: function loadEntries(offset) {
			var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;

			if (this.searchQuery) {
				return $.get(OC.generateUrl('/apps/logreader/search'), {
					offset: offset,
					count: count,
					query: this.query
				});
			} else {
				return $.get(OC.generateUrl('/apps/logreader/get'), {
					offset: offset,
					count: count
				});
			}
		}
	}, {
		key: 'getSettings',
		value: function () {
			var _ref2 = (0, _bluebird.coroutine)(regeneratorRuntime.mark(function _callee2() {
				return regeneratorRuntime.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								if (!this.cachedSettings) {
									_context2.next = 2;
									break;
								}

								return _context2.abrupt('return', this.cachedSettings);

							case 2:
								_context2.next = 4;
								return $.get(OC.generateUrl('/apps/logreader/settings'));

							case 4:
								this.cachedSettings = _context2.sent;
								return _context2.abrupt('return', this.cachedSettings);

							case 6:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, this);
			}));

			function getSettings() {
				return _ref2.apply(this, arguments);
			}

			return getSettings;
		}()
	}, {
		key: 'getLevels',
		value: function () {
			var _ref3 = (0, _bluebird.coroutine)(regeneratorRuntime.mark(function _callee3() {
				var _ref4, levels;

				return regeneratorRuntime.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								_context3.next = 2;
								return this.getSettings();

							case 2:
								_ref4 = _context3.sent;
								levels = _ref4.levels;
								return _context3.abrupt('return', levels.split('').map(function (level) {
									return level > 0;
								}));

							case 5:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, this);
			}));

			function getLevels() {
				return _ref3.apply(this, arguments);
			}

			return getLevels;
		}()
	}, {
		key: 'setLevels',
		value: function setLevels(levels) {
			var levelsString = levels.map(function (level) {
				return level ? 1 : 0;
			}).join('');
			return $.ajax({
				type: 'PUT',
				url: OC.generateUrl('/apps/logreader/levels'),
				data: { levels: levelsString }
			});
		}
	}, {
		key: 'getRelative',
		value: function () {
			var _ref5 = (0, _bluebird.coroutine)(regeneratorRuntime.mark(function _callee4() {
				var _ref6, relativedates;

				return regeneratorRuntime.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								_context4.next = 2;
								return this.getSettings();

							case 2:
								_ref6 = _context4.sent;
								relativedates = _ref6.relativedates;
								return _context4.abrupt('return', relativedates);

							case 5:
							case 'end':
								return _context4.stop();
						}
					}
				}, _callee4, this);
			}));

			function getRelative() {
				return _ref5.apply(this, arguments);
			}

			return getRelative;
		}()
	}, {
		key: 'getDateFormat',
		value: function () {
			var _ref7 = (0, _bluebird.coroutine)(regeneratorRuntime.mark(function _callee5() {
				var _ref8, dateformat;

				return regeneratorRuntime.wrap(function _callee5$(_context5) {
					while (1) {
						switch (_context5.prev = _context5.next) {
							case 0:
								_context5.next = 2;
								return this.getSettings();

							case 2:
								_ref8 = _context5.sent;
								dateformat = _ref8.dateformat;
								return _context5.abrupt('return', dateformat);

							case 5:
							case 'end':
								return _context5.stop();
						}
					}
				}, _callee5, this);
			}));

			function getDateFormat() {
				return _ref7.apply(this, arguments);
			}

			return getDateFormat;
		}()
	}, {
		key: 'getLive',
		value: function () {
			var _ref9 = (0, _bluebird.coroutine)(regeneratorRuntime.mark(function _callee6() {
				var _ref10, live;

				return regeneratorRuntime.wrap(function _callee6$(_context6) {
					while (1) {
						switch (_context6.prev = _context6.next) {
							case 0:
								_context6.next = 2;
								return this.getSettings();

							case 2:
								_ref10 = _context6.sent;
								live = _ref10.live;
								return _context6.abrupt('return', live);

							case 5:
							case 'end':
								return _context6.stop();
						}
					}
				}, _callee6, this);
			}));

			function getLive() {
				return _ref9.apply(this, arguments);
			}

			return getLive;
		}()
	}, {
		key: 'setRelative',
		value: function setRelative(relative) {
			return $.ajax({
				type: 'PUT',
				url: OC.generateUrl('/apps/logreader/relative'),
				data: { relative: relative }
			});
		}
	}, {
		key: 'setLive',
		value: function setLive(live) {
			return $.ajax({
				type: 'PUT',
				url: OC.generateUrl('/apps/logreader/live'),
				data: { live: live }
			});
		}
	}, {
		key: 'startPolling',
		value: function () {
			var _ref11 = (0, _bluebird.coroutine)(regeneratorRuntime.mark(function _callee7() {
				var lastReqId, newData;
				return regeneratorRuntime.wrap(function _callee7$(_context7) {
					while (1) {
						switch (_context7.prev = _context7.next) {
							case 0:
								if (!(this.cachedEntries.length === 0 || this.poll || this.pollActive)) {
									_context7.next = 2;
									break;
								}

								return _context7.abrupt('return');

							case 2:

								this.pollActive = true;
								this.poll = true;

							case 4:
								if (!this.poll) {
									_context7.next = 13;
									break;
								}

								lastReqId = this.cachedEntries[0].reqId;
								_context7.next = 8;
								return $.get(OC.generateUrl('/apps/logreader/poll'), {
									lastReqId: lastReqId
								});

							case 8:
								newData = _context7.sent;

								this.cachedEntries = newData.concat(this.cachedEntries);
								this.emit('entries', this.cachedEntries);
								_context7.next = 4;
								break;

							case 13:

								this.pollActive = false;

							case 14:
							case 'end':
								return _context7.stop();
						}
					}
				}, _callee7, this);
			}));

			function startPolling() {
				return _ref11.apply(this, arguments);
			}

			return startPolling;
		}()
	}, {
		key: 'stopPolling',
		value: function stopPolling() {
			this.poll = false;
		}
	}, {
		key: 'entries',
		get: function get() {
			return cachedEntries;
		}
	}, {
		key: 'query',
		set: function set(newQuery) {
			if (newQuery !== this.searchQuery) {
				this.searchQuery = newQuery;
				this.reset();
				this.load();
			}
		},
		get: function get() {
			return this.searchQuery;
		}
	}]);

	return LogProvider;
}(_events.EventEmitter);

LogProvider.levels = ['Debug', 'Info', 'Warning', 'Error', 'Fatal'];


//////////////////
// WEBPACK FOOTER
// ./js/Providers/LogProvider.js
// module id = 147
// module chunks = 0